"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _EverdaysLogoSVG = _interopRequireDefault(require("../EverdaysLogoSVG/EverdaysLogoSVG"));

require("./EverdaysSpinner.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EverdaysSpinner = function EverdaysSpinner(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#fff' : _ref$color;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "everdays-spinner"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    height: "40",
    width: "40",
    className: "circular"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "40",
    cy: "40",
    r: "32",
    fill: "none",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    stroke: color,
    className: "path"
  })), /*#__PURE__*/_react.default.createElement(_EverdaysLogoSVG.default, {
    fillColor: color,
    height: 40
  }));
};

EverdaysSpinner.propTypes = {
  color: _propTypes.string
};
var _default = EverdaysSpinner;
exports.default = _default;